// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import router from './router'
import { ServiceBus } from './ServiceBus.js'
import * as VueGoogleMaps from 'gmap-vue'
import SovecoNavBar from './components/reusable/SovecoNavBar'

import VueCookies from 'vue-cookies'
import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import Multiselect from 'vue-multiselect'
import VueLocalStorage from 'vue-localstorage'
import VModal from 'vue-js-modal'
import { Settings } from 'luxon'

Settings.defaultLocale = 'it'

require('../src/static/css/bulma091.min.css')
require('../src/static/css/vue-multiselect.min.css')
require('../src/static/css/sr.css')

//const api_server = "https://www.sovecotech.com/sovtech/api/index.php/"

Date.prototype.addDays = function (days) {
  this.setDate(this.getDate() + days)
}

Date.prototype.toLocaleShowString = function () {
  let pad = function (num) {
    let norm = Math.floor(Math.abs(num))
    return (norm < 10 ? '0' : '') + norm
  }
  return (
    this.getDate() +
    '-' +
    pad(this.getMonth() + 1) +
    '-' +
    pad(this.getFullYear()) +
    ' ' +
    pad(this.getHours()) +
    ':' +
    pad(this.getMinutes()) +
    ':' +
    pad(this.getSeconds())
  )
}

Date.prototype.toMysqlString = function () {
  let pad = function (num) {
    let norm = Math.floor(Math.abs(num))
    return (norm < 10 ? '0' : '') + norm
  }
  return (
    this.getFullYear() +
    '-' +
    pad(this.getMonth() + 1) +
    '-' +
    pad(this.getDate()) +
    ' ' +
    pad(this.getHours()) +
    ':' +
    pad(this.getMinutes()) +
    ':' +
    pad(this.getSeconds())
  )
}
Date.prototype.toShowString = function () {
  let pad = function (num) {
    let norm = Math.floor(Math.abs(num))
    return (norm < 10 ? '0' : '') + norm
  }
  return (
    pad(this.getDate()) +
    '-' +
    pad(this.getMonth() + 1) +
    '-' +
    this.getFullYear() +
    ' ' +
    pad(this.getHours()) +
    ':' +
    pad(this.getMinutes()) +
    ':' +
    pad(this.getSeconds())
  )
}

Date.prototype.toLocaleMysqlString = function () {
  let pad = function (num) {
    let norm = Math.floor(Math.abs(num))
    return (norm < 10 ? '0' : '') + norm
  }
  return (
    this.getFullYear() +
    '-' +
    pad(this.getMonth() + 1) +
    '-' +
    pad(this.getDate()) +
    ' ' +
    pad(this.getHours()) +
    ':' +
    pad(this.getMinutes()) +
    ':' +
    pad(this.getSeconds())
  )
}

Date.prototype.toLocaleMysqlSpecialString = function (flag) {
  if (flag) {
    this.setHours(23, 59, 59)
  } else {
    this.setHours(0, 0, 0)
  }

  let pad = function (num) {
    let norm = Math.floor(Math.abs(num))
    return (norm < 10 ? '0' : '') + norm
  }
  return (
    this.getFullYear() +
    '-' +
    pad(this.getMonth() + 1) +
    '-' +
    pad(this.getDate()) +
    ' ' +
    pad(this.getHours()) +
    ':' +
    pad(this.getMinutes()) +
    ':' +
    pad(this.getSeconds())
  )
}

Vue.use(VModal)
Vue.use(VuejsDialog, {
  html: true,
  loader: false,
  okText: 'Conferma',
  cancelText: 'Annulla',
  animation: 'bounce',
})
Vue.use(VueCookies)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC4SADt2OYarINemlIVf5kTSwp2ocs0BnQ',
    libraries: 'places',
  },
})
Vue.use(VueLocalStorage)

Vue.filter('pipe_filter', function (value) {
  if (!value) return ''
  let res = value.replace(/\|/g, ' ')
  return res
})
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
})
Vue.filter('pipe_filter_short', function (value) {
  if (!value) return ''
  let res = value.split('|')
  let s = ''
  for (let i = 0; i < (3 > res.length ? res.length : 3); i++) {
    s += res[i] + ' '
  }
  return s
})
Vue.filter('datesolo', function (value) {
  let pad = function (num) {
    let norm = Math.floor(Math.abs(num))
    return (norm < 10 ? '0' : '') + norm
  }
  let res = ''
  if (value) {
    res =
      pad(value.getDate()) +
      '-' +
      pad(parseInt(value.getMonth()) + 1) +
      '-' +
      pad(value.getFullYear())
  }
  return res
})
Vue.filter('sondenull_filter', function (value) {
  if (!value) return ''
  let res = ''
  if (value > -777) {
    res = value
  } else {
    res = '--'
  }
  return res
})
Vue.filter('empty_filter', function (value) {
  if (!value) return ''
  let res = ''
  if (value.indexOf('EMPTY') < 0) {
    res = ': ' + value
  } else {
    res = ': ' + 'NON PRESENTE'
  }
  return res
})
Vue.filter('mssg_filter', function (value) {
  if (!value) return ''
  let res = value.split('[')[0]
  return res
})
Vue.filter('mssg_filter_counter', function (value) {
  if (!value) return ''
  let res = ''
  if (value.indexOf('COUNTER') >= 0) {
    res = '[' + value.replace('[COUNTER', '') + ' ]'
  } else {
    res = value.split('[')[0]
  }
  return res
})
Vue.filter('date_reverse_filter', function (value) {
  if (!value) return ''
  let dd = value.split(' ')
  let res = dd[0].split('-').reverse().join('-') + ' ' + dd[1]
  return res
})
Vue.filter('date_reverse_filter', function (value) {
  if (!value) return ''
  let dd = value.split(' ')
  let res = dd[0].split('-').reverse().join('-') + ' ' + dd[1]
  return res
})
Vue.filter('date_reversesolo_filter', function (value) {
  if (!value) return ''
  let dd = value.split(' ')
  let res = dd[0].split('-').reverse().join('-')
  return res
})
Vue.filter('seconds_hhmmss', function (value) {
  let sec_num = parseInt(value, 10) // don't forget the second param
  let hours = Math.floor(sec_num / 3600)
  let minutes = Math.floor((sec_num - hours * 3600) / 60)
  let seconds = sec_num - hours * 3600 - minutes * 60

  if (hours < 10) {
    hours = '0' + hours
  }
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  if (seconds < 10) {
    seconds = '0' + seconds
  }
  return hours + ':' + minutes + ':' + seconds
})
// register globally
Vue.component('multiselect', Multiselect)
Vue.component('SovecoNavBar', SovecoNavBar)

Vue.config.productionTip = false

window.Vue = Vue

/* eslint-disable no-new */
new Vue({
  el: '#app',
  localStorage: {
    vehicle_cod: {
      type: String,
      default: '',
    },
  },
  router,
  render: (h) => h(App),
  components: {
    App,
  },
  data: {
    auth: {},
    user: {},
    last_pos: [],
  },

  created() {
    ServiceBus.$on('login', (a, b, c) => {
      this.do_login(a, b, c)
    })
  },
  methods: {
    // azzera i dati
    clear_data() {
      this.auth = {}
      this.user = {}
      this.last_pos = []
    },
  },
  template: '<App/>',
})
